// Section 22 centre area: the tab bar (arrow keys move between tabs, WAI-ARIA tabs) and the
// TabHost, which renders the active tab root from tab-slots.tsx.
import { h } from 'preact';
import type { Tab } from '../../store';
import { uiText } from '../text/en';
import { tabComponents, TAB_ORDER } from './tab-slots';

interface Props {
  tab: Tab;
  onTab: (tab: Tab) => void;
}

export function TabHost({ tab, onTab }: Props) {
  const move = (delta: number): void => {
    const i = TAB_ORDER.indexOf(tab);
    const next = TAB_ORDER[(i + delta + TAB_ORDER.length) % TAB_ORDER.length];
    if (next === undefined) return;
    onTab(next);
    document.getElementById(`tab-${next}`)?.focus();
  };
  return (
    <main class="work" id="work">
      <div
        class="tabs"
        role="tablist"
        aria-label={uiText.tabs.label}
        onKeyDown={(e) => {
          if (e.key === 'ArrowRight') move(1);
          else if (e.key === 'ArrowLeft') move(-1);
          else return;
          e.preventDefault();
        }}
      >
        {TAB_ORDER.map((id) => (
          <button
            key={id}
            id={`tab-${id}`}
            type="button"
            role="tab"
            class={`tab${id === tab ? ' is-active' : ''}`}
            aria-selected={id === tab}
            aria-controls="tabpanel"
            tabIndex={id === tab ? 0 : -1}
            onClick={() => onTab(id)}
          >
            {uiText.tabs[id]}
          </button>
        ))}
      </div>
      <div id="tabpanel" class="tabpanel" role="tabpanel" aria-labelledby={`tab-${tab}`}>
        {h(tabComponents[tab], {})}
      </div>
    </main>
  );
}
